import { Component, OnInit, OnDestroy, Inject, PLATFORM_ID, Renderer2, ElementRef, ViewChild, HostListener } from '@angular/core';
import { CompanyService } from '../../../services/company.service';
import { UserService } from '../../../services/user.service';

import { ActivatedRoute, Router } from '@angular/router';
import { AppDataService } from '../../../services/app-data.service';
declare var Swal: any;
declare var $:any;
@Component({
  selector: 'upload',
  templateUrl: './upload.html',
})
export class UploadComponent implements OnInit, OnDestroy {
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private renderer: Renderer2,
    private route: ActivatedRoute,
    private _companyService: CompanyService,
    private _auth: UserService,
    public _appData: AppDataService,
    public _routeParams : ActivatedRoute

  ) {

  }
    public menuOpen=true;
    public menuConfig={};
    public items:any[] = [  ];
    public roomName='';
    public fileExtension: string = '';
    public room;
    public image2DIdx: number = null;
    public imageLoading: number = 0;
  ngOnDestroy(): void {
      
  }
  ngOnInit(): void {


  }

  doLink(name,description){
    let link='';
    let thumbnail='';
                      let date=new Date();
                  let time=date.getTime();
      Swal.fire({
        title: "Type the url of the embedded site",
        input: "text",
        inputAttributes: {
          autocapitalize: "off"
        },
        showCancelButton: true,
        confirmButtonText: "OK",
        showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.value) {
            link=result.value;
            Swal.fire({
              title: "Give the url of the thumbnail image",
              input: "text",
              inputAttributes: {
                autocapitalize: "off"
              },
              showCancelButton: true,
              confirmButtonText: "OK",
              showLoaderOnConfirm: true,
              }).then((result) => {
                if (result.value) {
                  thumbnail=result.value;
                

                          const social = {
                        user: {
                          uid: this._appData.instagramUser.uid,
                          name: this._appData.instagramUser.full_name,
                          photo: this._appData.instagramUser.profile_picture,
                          company: false
                        },
                        id: time.toString(),
                        photo: thumbnail,
                        name: name,
                        description: description,
                        views: 0,
                        likes: 0,
                        owner: this._appData.instagramUser.uid,
                        comments: [],
                        link: link,
                        kind: 'link'
                      };
                      this._companyService.getSocial(social).set(social).then(() => {
                        Swal.close();
                        Swal.fire({ title: 'Imagens Processadas' });
                        this.image2DIdx = null;
                      });
                }
              })
            }
          })

  }
  upload(extension){
    if (!this._appData.instagramUser){
      this._appData.page='social';
      $('#registerSocialModal').modal('show')
      this._appData.tiping=true;
    }
    else{
      this.fileExtension=extension;
      let name='';
      let description='';
      Swal.fire({
        title: "Give a name for your picture",
        input: "text",
        inputAttributes: {
          autocapitalize: "off"
        },
        showCancelButton: true,
        confirmButtonText: "OK",
        showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.value) {
            name=result.value;
            Swal.fire({
              title: "Give a description for your picture",
              input: "text",
              inputAttributes: {
                autocapitalize: "off"
              },
              showCancelButton: true,
              confirmButtonText: "OK",
              showLoaderOnConfirm: true,
              }).then((result) => {
                if (result.value) {
                  description=result.value;
                  let date=new Date();
                  let time=date.getTime();
                  this.room={
                    id:time.toString(),
                    roomName:name,
                    description:description,
                    admin:[this._appData.instagramUser.uid],
                    collisions:[],
                    user:this._appData.instagramUser.uid,
                    defaultPlace:{x:0,y:0,z:0},
                    defaultSpace:0,
                    event:'1592880902713',
                    backgroundPhoto:[],
                    textures:{},
                    nonisometric:false,
                    version:'1'
                  }
                    if (extension=='jpg' || extension=='png'){
                      $('#background2dUploader').click();
                    }
                    if (extension=='multiple'){
                      $('#background2dMultipleUploader').click();
                    }
                    if (extension=='mp4'){
                      $('#backgroundvideoUploader').click();
                    }
                    if (extension=='application/octet-stream'){
                      $('#backgroundmodelUploader').click();
                    }
                    if (extension=='link'){
                      this.doLink(name,description)
                    }
                }
              });
          }
        });
    }
  }
  public validateBackgroundPhotoFiles(files: File[]): { valid: boolean, message?: string } {
	  const ids: string[] = [];
	  const transitionsMap: Record<string, string[]> = {};
	  const errors: string[] = [];

	  for (const file of files) {
		const baseName = file.name.split('.')[0];
		const segments = baseName.split('-');

		const idIndex = segments.indexOf('id');
		if (idIndex === -1 || !segments[idIndex + 1]) {
		  errors.push(`Arquivo "${file.name}" não possui "id-<ID>" corretamente formatado.`);
		  continue;
		}

		const id = segments[idIndex + 1];

		if (!/^\d+$/.test(id)) {
		  errors.push(`Arquivo "${file.name}" possui ID inválido: "${id}". IDs devem ser numéricos.`);
		  continue;
		}

		if (ids.includes(id)) {
		  errors.push(`ID duplicado encontrado: "${id}" no arquivo "${file.name}".`);
		  continue;
		}

		ids.push(id);

		// Coleta as transições desse arquivo
		const transitions: string[] = [];
		for (let i = idIndex + 2; i < segments.length; i++) {
		  if (segments[i] === 't') {
			const nextId = segments[i + 1];
			if (!nextId || !/^\d+$/.test(nextId)) {
			  errors.push(`Transição mal formatada em "${file.name}". Exemplo correto: id-160-t-161.`);
			  continue;
			}
			transitions.push(nextId);
			i++; // pula o id da transição já processado
		  }
		}

		transitionsMap[id] = transitions;
	  }

	  // Verifica se todas as transições apontam para IDs existentes
	  for (const [id, transitions] of Object.entries(transitionsMap)) {
		for (const targetId of transitions) {
		  if (!ids.includes(targetId)) {
			errors.push(`Arquivo com id "${id}" possui transição para ID inexistente: "${targetId}".`);
		  }
		}
	  }

	  if (errors.length > 0) {
		const message = 'Erros encontrados nos arquivos de upload:\n\n' + errors.join('\n');

		return { valid: false, message: message };
	  }

	  return { valid: true };
}
 public uploadRoomBackground(fileInput: any) {
  const files: FileList = fileInput.target.files;
  if (!files || files.length === 0) return;

  const validTypes = ['image/png', 'image/jpeg','video/mp4'];
  const parsedFiles: {
    file: File;
    id?: string;
    transitions?: string[];
  }[] = [];

  let usesCustomIds = true;


	const filesArray : File[] = Array.from(fileInput.target.files);

	const validation = this.validateBackgroundPhotoFiles(filesArray);

	if (!validation.valid) {
    fileInput.target.value = '';
		Swal.fire({title:'Error',text:validation.message})
	  return; // Para a execução se houver erro
	}

  Array.from(files).forEach((file: File) => {
    if (!validTypes.includes(file.type)) {
      alert('Por favor, selecione apenas arquivos PNG ou JPG ou MP4.');
      return;
    }

    const baseName = file.name.split('.')[0];
    const segments = baseName.split('-');
    const idIndex = segments.indexOf('id');

    if (idIndex === -1 || !segments[idIndex + 1]) {
      usesCustomIds = false; // se algum não tem id-, cai na lógica padrão
    }

    if (usesCustomIds) {
      const id = segments[idIndex + 1];
      const transitions: string[] = [];

      for (let i = idIndex + 2; i < segments.length; i++) {
        if (segments[i] === 't' && segments[i + 1]) {
          transitions.push(segments[i + 1]);
        }
      }

      parsedFiles.push({ file, id, transitions });
    } else {
      parsedFiles.push({ file }); // sem ID nem transições
    }
  });
  fileInput.target.value = '';

  this.imageLoading = 0;

  if (usesCustomIds) {
    // === MODO AVANÇADO (com id e transições definidas por nome de arquivo) ===
    parsedFiles.forEach(({ file, id, transitions }, index) => {
      const image2DIdx = this.room.backgroundPhoto.length;
      const photoItem = {
        pbig: '',
        pmed: '',
        psma: '',
        x: 0,
        y: 0,
        ra: 10,
        r: 0,
        id: id!,
        transaction: 'n/a',
        transitions: (transitions || []).map((tid, i) => ({
          idx: tid,
          nextAngle: 0,
          rx: 0,
          ry: 0,
          rz: 0,
          sx: 1,
          sy: 1,
          sz: 1,
          x: i % 2 === 0 ? -5 : 5,
          y: 0,
          z: 0
        }))
      };

      this.room.backgroundPhoto.push(photoItem);
	  
      if (file.name.indexOf('mp4')>0){
        this.uploadFile(file, image2DIdx+'.mp4', 'backgroundPhoto', 'video', image2DIdx);
    
      }
      else{
        this.resizeAndUploadImage(file, 4096, 2048, 'pbig', 'png', image2DIdx);
        this.resizeAndUploadImage(file, 2048, 1024, 'pmed', 'png', image2DIdx);
        this.resizeAndUploadImage(file, 1024, 512, 'psma', 'png', image2DIdx);
      }
    });

  } else {
    // === MODO PADRÃO (sem nomes com id-, gerar tudo automático) ===
    parsedFiles.forEach(({ file }, index) => {
      const time = Date.now() + index;
      const image2DIdx = this.room.backgroundPhoto.length;
      const photoItem = {
        pbig: '',
        pmed: '',
        psma: '',
        x: 0,
        y: 0,
        ra: 10,
        r: 0,
        id: time.toString(),
        transaction: 'n/a',
        transitions: [] // preenchido depois
      };

      this.room.backgroundPhoto.push(photoItem);
      if (file.name.indexOf('mp4')>0){
        this.uploadFile(file, image2DIdx+'.mp4', 'backgroundPhoto', 'video', image2DIdx);
      
      }
      else{
        this.resizeAndUploadImage(file!, 4096, 2048, 'pbig', 'png', image2DIdx);
        this.resizeAndUploadImage(file!, 2048, 1024, 'pmed', 'png', image2DIdx);
        this.resizeAndUploadImage(file!, 1024, 512, 'psma', 'png', image2DIdx);
      }
    });

    // Preenche transições automáticas ao final do upload
    this.autoCreateTransitionsAfterUpload = true;
  }
}
private autoCreateTransitionsAfterUpload: boolean = false;

public async resizeAndUploadImage(
  file: File,
  width: number,
  height: number,
  kind: string,
  fileExtension: string,
  image2DIdx: number
) {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  const img = new Image();
  img.crossOrigin = 'anonymous';

  img.onload = async () => {
    canvas.width = width;
    canvas.height = height;
    ctx.drawImage(img, 0, 0, width, height);

    canvas.toBlob(async (blob) => {
      if (!blob) {
        console.error('Erro ao criar Blob da imagem redimensionada.');
        return;
      }

      const processedFile = new File([blob], `${image2DIdx}.${fileExtension}`, {
        type: `image/${fileExtension}`
      });

      this.uploadFile(processedFile, `${image2DIdx}.${fileExtension}`, 'backgroundPhoto', kind, image2DIdx);
    }, `image/${fileExtension}`);
  };

  img.onerror = (error) => {
    console.error('Erro ao carregar a imagem:', error);
  };

  img.src = URL.createObjectURL(file);
}
public uploadFile(
  file: File,
  newfile: string,
  location: string,
  kind: string,
  image2DIdx: number
) {
  const maxSize = 4 * 1024 * 1024;
  this.imageLoading++;

  $('#editCardModal').modal('hide');
  Swal.fire({
    title: 'WAIT',
    text: 'PROCESSING UPLOAD',
    imageUrl: "https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/gameImages%2Ftransfer.gif?alt=media&token=67c0bdef-76b4-40e5-8fdb-65501ef94aff",
    showConfirmButton: false
  });

  const path = `events/${this.room.event}/rooms/${this.room.id}/background/${location}/${kind}/`;

  this._auth.uploadToFirebase(file, newfile, path).subscribe(snapshot => {
    snapshot.ref.getDownloadURL().then(url => {
      this.imageLoading--;

      if (location === 'backgroundPhoto') {
        this.room.backgroundPhoto[image2DIdx][kind] = url;

        // Quando todos os uploads finalizarem
        if (this.imageLoading === 0) {

          if (this.autoCreateTransitionsAfterUpload) {
            for (let i = 0; i < this.room.backgroundPhoto.length; i++) {
              const current = this.room.backgroundPhoto[i];
              current.transitions = [];
              if (i==0){
                this.room.defaultSpace=this.room.backgroundPhoto[0].id;
              }
              const prev = this.room.backgroundPhoto[i - 1];
              const next = this.room.backgroundPhoto[i + 1];

              if (prev) {
                current.transitions.push({
                  idx: prev.id,
                  nextAngle: 0,
                  rx: 0,
                  ry: 0,
                  rz: 0,
                  sx: 1,
                  sy: 1,
                  sz: 1,
                  x: -5,
                  y: 0,
                  z: 0
                });
              }

              if (next) {
                current.transitions.push({
                  idx: next.id,
                  nextAngle: 0,
                  rx: 0,
                  ry: 0,
                  rz: 0,
                  sx: 1,
                  sy: 1,
                  sz: 1,
                  x: 5,
                  y: 0,
                  z: 0
                });
              }
            }
            this.autoCreateTransitionsAfterUpload = false; // reset
          }

          this._companyService.getRoom(this.room.id).set(this.room);

          const social = {
            user: {
              uid: this._appData.instagramUser.uid,
              name: this._appData.instagramUser.full_name,
              photo: this._appData.instagramUser.profile_picture,
              company: false
            },
            id: this.room.id,
            photo: this.room.backgroundPhoto[0].pmed,
            name: this.room.roomName,
            description: '',
            views: 0,
            likes: 0,
            comments: [],
            link: `/gameevent/${this.room.event}?room=${this.room.id}`,
            kind: '360tour'
          };

          this._companyService.getSocial(social).set(social).then(() => {
            Swal.close();
            Swal.fire({ title: 'Imagens Processadas' });
            this.image2DIdx = null;
          });
        }
      }
    });
  });
}

public resizeImage(file: File, maxWidth: number, maxHeight: number): Promise<Blob> {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = maxWidth;
      canvas.height = maxHeight;

      const ctx = canvas.getContext('2d');
      ctx.drawImage(image, 0, 0, maxWidth, maxHeight);

      canvas.toBlob((blob) => {
        if (blob) {
          resolve(blob);
        } else {
          reject(new Error('Erro ao criar Blob da imagem redimensionada.'));
        }
      }, 'image/png');
    };
    image.onerror = reject;
    image.src = URL.createObjectURL(file);
  });
}


 }



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/social/upload/upload.ts